import { create } from 'zustand';

/**
 * Desktop sidebar collapse state.
 *
 * On lg+ the sidebar can collapse to an icon-only rail to give wide content
 * (Gantt, resource heatmap, report tables) the full 240px back. The choice is
 * persisted to localStorage so it survives reloads. Phone drawer is unaffected.
 */
const STORAGE_KEY = 'projexhq.sidebar.collapsed';

function readInitial(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

interface SidebarState {
  collapsed: boolean;
  toggle: () => void;
  setCollapsed: (v: boolean) => void;
}

function persist(v: boolean) {
  try {
    localStorage.setItem(STORAGE_KEY, v ? '1' : '0');
  } catch {
    /* private mode / storage disabled — in-memory only */
  }
}

export const useSidebarStore = create<SidebarState>((set) => ({
  collapsed: readInitial(),
  toggle: () =>
    set((s) => {
      const next = !s.collapsed;
      persist(next);
      return { collapsed: next };
    }),
  setCollapsed: (v) => {
    persist(v);
    set({ collapsed: v });
  },
}));
